import Vue from 'vue'
import has from '@/directives/has'
import drag from './drag'
Vue.directive('has', has)
Vue.directive('drag', {
    inserted: drag
})